export default __webpack_public_path__ + "static/media/fb-icon.4e4fe8f1.svg";